import {MortgageId, PaymentId} from '../domain/scenario.model';

export const financeStateId = 'finance';

export interface AppState {
  [financeStateId]: FinanceState;
  config: ConfigState;
}

export interface Dictionary<T> {
  [key: string]: T;
}

export interface ConfigState {
  logView: boolean;
}

export interface FinanceState {
  scenarioIds: string[];
  lastScenarioId: string | null;
  scenarios: Dictionary<Scenario>;
}

export interface Scenario {
  mortgages: Dictionary<MortgageOverview>;
  mortgageCount: number;
  inflationRate: number; // Percentage
  useInflationCorrection: boolean;
  id: string;
}

export interface MortgageOverview {
  timeline: MortgageMonth[];
  contract: MortgageContract;
  mortgageId: MortgageId;
  payments: Dictionary<PaymentOverview>;
  lastPaymentId: PaymentId | null;
}

export enum ContractType {
  LINEAR = 'LINEAR',
  ANNUITY_MONTHLY = 'ANNUITY_MONTHLY',
  INTEREST_ONLY = 'INTEREST_ONLY',
  SAVING = 'SAVING'
}

export interface MortgageMonth {
  readonly month: number;
  readonly newPrincipalPayment: number; // principal payed this month
  readonly newInterestPayment: number;  // interest payed this month
  readonly currentTotalPrincipalPayment: number; // total principal payed after this month
  readonly currentTotalInterestPayment: number; // total interest payed after this month
  readonly currentRemainder: number; // remaining principal after this month
  readonly contract: MortgageContract; // contract on which this month is based
  readonly newPremiumPayment: number; // premium payed this month ; if you have a insurance-based mortgage (eg. savings mortgage)
  readonly currentTotalPremiumPayment: number; // total premium payed after this month
}

export interface MortgageContract {
  readonly contractType: ContractType;
  readonly mortgagedAmount: number;
  readonly interestRate: number;
  readonly durationMonths: number; // duration of the interest
  readonly monthlyPremium: number | null;  // if you have a insurance-based mortgage (eg. savings mortgage)
  readonly startDate: number;
}


export interface PaymentOverview {
  plan: PaymentPlan;
  timeline: Payment[];
  paymentId: PaymentId;
}

export interface PaymentPlan {
  planType: PaymentPlanType;
  startAtMonth: number;
  amount: number;
}

export interface Payment {
  month: number;
  amount: number;
}

export enum PaymentPlanType {
  ONCE = 'ONCE',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}


